function remove_last_char(string){
    string = string+'';
    let len = string.length;
    return string.substr(0, (len - 1)); //remove invalid value
}

export default remove_last_char;